// Copyright Epic Games, Inc. All Rights Reserved.

import styled from "styled-components";
import { Alert as AlertIcon } from "@epic-ui/icons";
import { WithTheme } from "@material-ui/core";

export const ErrorIcon = styled(AlertIcon)(({ theme }: WithTheme) => ({
  color: theme.palette.error.light,
  fontSize: "1.5rem",
  marginRight: "46px",
}));
